import { Inject } from "typescript-ioc";
import { UiComponent } from "./UiComponent";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";

export class Image extends UiComponent {
    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    /**
     * UI component's context element in the DOM.
     */
    public get context(): HTMLImageElement {
        return this.getContextAs(HTMLImageElement);
    }

    /**
     * @returns Current value of the href property / attribute of the context element.
     */
    public getSrc(): string {
        return this.context.src;
    }

    /**
     * Sets a new value of the href property / attribute on context element.
     * @value href property / attribute value to be set.
     */
    public setSrc(value: string): this {
        this.context.src = value;

        return this;
    }
}
